export const TRANSPORTTABLE = [
  {
    title: '订单号',
    dataIndex: 'odrNo',
    scopedSlots: { customRender: 'odrNo' },
    fixed: 'left',
    width: 210
  },
  {
    title: '订单状态',
    dataIndex: 'statusText',
    scopedSlots: { customRender: 'statusText' },
    width: 160,
  },
  {
    title: '货品信息',
    dataIndex: 'goosInfo',
    scopedSlots: { customRender: 'goosInfo' },
    width: 170
  },
  {
    title: '发货地信息',
    dataIndex: 'startAddress',
    scopedSlots: { customRender: 'startAddress' },
    width: 240
  },
  {
    title: '收货地信息',
    dataIndex: 'endAddress',
    scopedSlots: { customRender: 'endAddress' },
    width: 240
  },
  {
    title: '订单总金额(元)',
    dataIndex: 'orderAmount',
    scopedSlots: { customRender: 'orderAmount' },
    width: 150
  },
  {
    title: '派车信息',
    dataIndex: 'dispatchInfo',
    scopedSlots: { customRender: 'dispatchInfo' },
    width: 200
  },
  {
    title: '下单信息',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
    width: 200
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
    width: 200
  },
];

export const WAREHOSERABLE = [
  {
    title: '订单号',
    dataIndex: 'unifyOdrNo',
    scopedSlots: { customRender: 'unifyOdrNo' },
    fixed: 'left',
    width: 210
  },
  {
    title: '订单状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    width: 160,
  },
  {
    title: '订单类型',
    dataIndex: 'scene',
    scopedSlots: { customRender: 'scene' },
    width: 170
  },
  {
    title: '仓货主',
    dataIndex: 'customerName',
    scopedSlots: { customRender: 'customerName' },
    width: 210
  },
  {
    title: '仓库',
    dataIndex: 'warehouse',
    scopedSlots: { customRender: 'warehouse' },
    width: 170
  },
  {
    title: '货品信息',
    dataIndex: 'goosInfo',
    scopedSlots: { customRender: 'goosInfo' },
    width: 170
  },
  {
    title: '运输地点',
    dataIndex: 'consignorAddress',
    scopedSlots: { customRender: 'startAddress' },
    width: 240
  },
  {
    title: '订单总金额(元)',
    dataIndex: 'cost',
    scopedSlots: { customRender: 'orderAmount' },
    width: 150
  },
  {
    title: '派车信息',
    dataIndex: 'dispatchInfo',
    scopedSlots: { customRender: 'dispatchInfo' },
    width: 200
  },
  {
    title: '下单信息',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
    width: 200
  },
  {
    title: '下单货主',
    dataIndex: 'tenantName',
    scopedSlots: { customRender: 'tenantName' },
    width: 210
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
    width: 200
  },
]

export const UnifyOrderStatus = {
  DRAFT: '待接单',
  SUBMITTED: '待接单',  
  DEAL: '待派车',  
  BIDDING: '议价中', 
  STARTED: '运输中',  
  SIGNED: '已签收', 
  CANCELED: '已取消', 
  EXP_CAL_STATUS: '计费异常',
  PART_SIGNED: '部分签收',
  DISPATCHED: '已派车',
  CARRIER_BIDDING: '询价中'
}

export const UnifyOrderStatusKey = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',  
  DEAL: 'DEAL',  
  BIDDING: 'BIDDING', 
  STARTED: 'STARTED',  
  SIGNED: 'SIGNED', 
  CANCELED: 'CANCELED', 
  EXP_CAL_STATUS: 'EXP_CAL_STATUS',
  PART_SIGNED: 'PART_SIGNED',
  DISPATCHED: 'DISPATCHED',
  CARRIER_BIDDING: 'CARRIER_BIDDING',
}

// 议价中报价状态
export const biddingList = {
  BIDDING:'BIDDING', // ("报价中")
  NORMAL_BID: 'NORMAL_BID', // ("正常报价"),
  NO_BID: 'NO_BID', // ("无人报价"),
  DEAL: 'DEAL', // ("已达成报价"),
  DISABLED: 'DISABLED', // ("无效报价, 重新出价"),
}

// 仓配一体
export const OrderStatusCode = {
  TO_BE_SUBMITTED: {
    val: '0',
  }, // 待提交，货主端文案用待提交
  TO_BE_DISPATCH: {
    val: '2',
  }, // 待派车
  TO_BE_START: {
    val: '3'
  }, // 待提货
  TO_BE_SIGN: {
    val: '4',
  }, // 运输中-代签收
  PART_SIGN: {
    val: '5',
  }, // 运输中-部分签收
  IN_TRANSIT: {
    val: '4,5',
  }, // 运输中
  BALANCE_CHECK: {
    val: '6',
  }, // 已签收
  CANCEL: {
    val: '9',
    defalutNotShow: true,
  }, // 已取消
  ABNORMAL: {
    val: '100',
  }, // 异常
}

export const WarehoseOrderStatus = {
  [OrderStatusCode.TO_BE_SUBMITTED.val]: '待接单', // 待提交，货主端文案也用待提交
  [OrderStatusCode.TO_BE_DISPATCH.val]: '待派车', // 待派车
  [OrderStatusCode.TO_BE_START.val]: '待提货', // 待提货
  [OrderStatusCode.TO_BE_SIGN.val]: '运输中', // 运输中-代签收
  [OrderStatusCode.PART_SIGN.val]: '运输中', // 运输中-部分签收
  [OrderStatusCode.IN_TRANSIT.val]: '运输中', // 运输中
  [OrderStatusCode.BALANCE_CHECK.val]: '已签收', // 已签收
  [OrderStatusCode.CANCEL.val]: '已取消', // 已取消
  [OrderStatusCode.ABNORMAL.val]: '异常', // 异常
}

const scene = {
  'DELIVER_ONLY': 'DELIVER_ONLY',            // 出库
  'DELIVER_TRANSPORT': 'DELIVER_TRANSPORT',  // 出库运输
  'STORE_ONLY': 'STORE_ONLY',  // 入库运输
  'STORE_TRANSPORT': 'TRANSPORT_STORE',  // 入库运输
  'DELIVER_STORE': 'DELIVER_STORE',  // 仓内调拨
  'DELIVER_TRANSPORT_STORE': 'DELIVER_TRANSPORT_STORE',  // 仓间调拨
}
// 订单类型
export const SCENE = scene

export const WAREHOSESTATUS = {
  draft: 'DRAFT',
  submitted: 'SUBMITTED',
  deal: 'DEAL',
  toBeDeliver: 'TO_BE_DELIVER',
  delivering: 'DELIVERING',
  delivered: 'DELIVERED',
  dispatched: 'DISPATCHED',
  started: 'STARTED',
  signed: 'SIGNED',
  toBeStore: 'TO_BE_STORE',
  storing: 'STORING',
  stored: 'STORED',
  finished: 'FINISHED',
  canceled: 'CANCELED',
  rejected: 'REJECTED',
  expStatus: 'EXP_CAL_STATUS',
  partSigned: 'PART_SIGNED',
  preDraft: 'PRE_DRAFT'
};

export const WAREHOSESTATUSTEXT = {
  [WAREHOSESTATUS.draft]: '草稿',
  [WAREHOSESTATUS.submitted]: '待接单',
  [WAREHOSESTATUS.deal]: '待派车',
  [WAREHOSESTATUS.delivering]: '出库中',
  [WAREHOSESTATUS.toBeDeliver]: '待出库',
  [WAREHOSESTATUS.delivered]: '已出库',
  [WAREHOSESTATUS.dispatched]: '已派车',
  [WAREHOSESTATUS.started]: '运输中',
  [WAREHOSESTATUS.signed]: '已签收',
  [WAREHOSESTATUS.toBeStore]: '待入库',
  [WAREHOSESTATUS.storing]: '入库中',
  [WAREHOSESTATUS.stored]: '已入库',
  [WAREHOSESTATUS.finished]: '已完成',
  [WAREHOSESTATUS.canceled]: '已取消',
  [WAREHOSESTATUS.rejected]: '已拒收',
  [WAREHOSESTATUS.expStatus]: '异常',
  [WAREHOSESTATUS.partSigned]: '部分签收',
  [WAREHOSESTATUS.preDraft]: '信息错误',
};

export const typeNum = {
  PRICE: {
    value: 'PRICE',
    transport: 'transport_price_exception_num',
    wharehose: 'warehouse_delivery_price_exception_num'
  },
  OUTBOUND: {
    value: 'OUTBOUND',
    transport: 'transport_outbound_exception_num',
    wharehose: 'warehouse_delivery_outbound_exception_num'
  },
  DISPATCH_TIMEOUT: {
    value: 'DISPATCH_TIMEOUT',
    transport: 'transport_dispatch_timeout_num',
    wharehose: 'warehouse_delivery_dispatch_timeout_num'
  },
  PICK_TIMEOUT: {
    value: 'PICK_TIMEOUT',
    transport: 'transport_pick_timeout_num',
    wharehose: 'warehouse_delivery_pick_timeout_num'
  },
  SIGN_TIMEOUT: {
    value: 'SIGN_TIMEOUT',
    transport: 'transport_sign_timeout_num',
    wharehose: 'warehouse_delivery_sign_timeout_num'
  },
  TEMPERATURE: {
    value: 'TEMPERATURE',
    transport: 'transport_temperature_exception_cnt',
    wharehose: 'warehouse_delivery_temperature_exception_cnt'
  },
  CARGO_WARNING: {
    value: 'CARGO_WARNING',
    transport: 'transport_cargo_warning_num',
    wharehose: 'warehouse_cargo_warning_num'
  }
}
